import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "./Button";
import SignatureCanvas from "react-signature-canvas";
import { AppContext } from "../context";
import {
  initializeEmail,
  setLog,
  userLogs,
  patLogs,
  setResumeFlowEmail,
  translateText,
  vinCheckDB,
  setHyundaiData,
  signatureUpload,
  setquestionValue,
} from "../context/utils";
import Navbar from "./Navbar";

let logsbugs = true;

const PRE_QUESTION_PERSONAS = {
  // Persona 4 & 8
  1: {
    question:
      "Are you at the agreed drop off address listed in the confirmation email/text you received from U-Haul Vehicle Share?",
    type: "yesno",
    notice:
      "To begin the Vehicle Shipping process, this inspection needs to be completed at the agreed drop off address listed in the confirmation email/text you received from U-Haul Vehicle Share.  Call/text 623-473-0205 with any questions or feedback.",
  },
  // Persona 5 & 9
  2: {
    question: "Is the Driver there now to pick up the vehicle?",
    type: "yesno",
    notice:
      "This inspection is to be completed at the time the Driver is taking possession of the vehicle.  Call/text 623-473-0205 with any questions or feedback.",
  },
  // Persona 6 & 10
  3: {
    question: "Who are you?",
    type: "options",
    options: [
      {
        label: "Driver",
        value: "driver",
        advisory:
          "Complete this inspection at the delivery address provided in the confirmation email/text received from U-Haul Vehicle Share with the trailer disconnected from the truck. Call/text 623-473-0205 with any questions or feedback.",
      },
      {
        label: "U-Haul Team Member",
        value: "team_member",
        advisory:
          "This inspection is to be completed when the Driver is delivering the vehicle.  Call/Text 623-473-0205 with any questions or feedback",
      },
    ],
  },
  // Persona 7 & 11
  4: {
    question:
      "Is the vehicle owner there NOW to take possession of the vehicle?",
    type: "yesno",
    notice:
      "Complete this inspection only when the vehicle owner is present.  The vehicle owner must provide the VSC # and their ID for name verification.  Call/text 623-473-0205 with any questions or feedback.",
  },
};

const CarlFrontQuestion = () => {
  const {
    stepCovered,
    setStepCovered,
    setScreen,
    setUserEmail,
    clientId,
    token,
    inspectionId,
    config,
    showAlert,
    setCurrentPage,
    currentPage,
    setStartPing,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);
  const [questionValue, setQuestionValue] = useState(null);

  const persona =
    PRE_QUESTION_PERSONAS[
      Object.keys(config).includes("preQuestionInspection")
        ? config["preQuestionInspection"]
        : 0
    ];

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      return text;
    }
  };

  const goToInspection = () => {
    if (config["email"]) {
      setScreen("email");
    } else {
      setScreen("instructions");
    }
  };

  const options =
    persona?.type === "yesno"
      ? [
          { label: "YES", value: "yes" },
          { label: "NO", value: "no" },
        ]
      : persona?.options || [];

  const noticeText =
    persona?.type === "yesno"
      ? questionValue === "no"
        ? persona.notice
        : null
      : persona?.options.find((option) => option.value === questionValue)
          ?.advisory;

  const canProceed = persona?.type === "yesno"
    ? questionValue === "yes"
    : Boolean(questionValue);

  return (
    <div
      className="screen_email"
      style={{
        height: screenHeight ? "100dvh" : "",
        position: screenHeight ? "relative" : "",
        padding: screenHeight ? "0%" : "",
        width: "100dvw",
      }}
    >
      <Navbar />
      {!persona ? (
        <h3 style={{ textAlign: "left" }}>Carl Front Question</h3>
      ) : (
        <>
          <div style={{ textAlign: "left", width: "90%", margin: "0 auto" }}>
            <h3>{persona.question}</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {options.map((option) => (
                <div className="label-div" key={option.value}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "var(--app-text, #000)",
                    }}
                  >
                    <input
                      type="radio"
                      name="carlFrontQuestion"
                      value={option.value}
                      checked={questionValue === option.value}
                      onChange={() => setQuestionValue(option.value)}
                    />
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
            {noticeText && <h3 style={{ marginTop: "16px" }}>{noticeText}</h3>}
          </div>
          <div
            className="form-btn"
            style={{
              width: "100%",
              height: screenHeight ? "auto" : "",
              position: screenHeight ? "absolute" : "",
              bottom: screenHeight ? "10px" : "",
              padding: screenHeight ? "0px 2px" : "",
            }}
          >
            <button
              disabled={!canProceed}
              style={{
                backgroundColor: config["colors"]["btn"],
                width: "96%",
                height: "60px",
                margin: "0px",
                opacity: !canProceed ? 0.3 : 1,
              }}
              onClick={() => {
                goToInspection();
              }}
            >
              {getTranslateText("Continue")}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CarlFrontQuestion;
